<template>
  <section>
    <h1 class="sponsor__title">Sponsorship Levels:</h1>
    <div
      class="yachad-styled styled-radio-container styled-radio-container--ou-donation row"
    >
      <div
        v-for="([amount, description], index) of amounts.slice(0, 11)"
        :key="`${amount}_${index}`"
        class="amount-row"
      >
        <input
        :id="`${amount}_${index}`"
          type="radio"
          class="amount"
          @click="
          selectedAmount = amount;
          selectedDescription = description;
        "
        :checked="selectedAmount == amount && selectedDescription == description"
      />
        <FormLabel :for="`${amount}_${index}`">
          <MoneyFormat
            class="label-amount"
            :value="amount"
            :currencyCode="form.currency"
            :hide-subunits="true"
          />
          <span class="label-description" v-html="description"></span>
        </FormLabel>
      </div>
    </div>

    <div class="amount_other__wrapper amount-row">
    <label>Other</label>
      <input id="amount_other_check" type="radio" class="amount" :checked="customSelected" @click="customSelected = true">
      <input type="number" name="amount_other" placeholder="Other amount" v-model="customAmount" />
    </div>

    <!-- <h3 class="sponsor__subtitle">Corporate Sponsors</h3>

    <div
      class="yachad-styled styled-radio-container styled-radio-container--ou-donation row"
    >
      <div
        v-for="[amount, description] of amounts.slice(10, 14)"
        :key="amount"
        class="amount-row"
      >
        <input
          :id="`amount${amount}`"
          type="radio"
          class="amount"
          @click="
          selectedAmount = amount;
          selectedDescription = description;
        "
        :checked="selectedAmount == amount && selectedDescription == description"
      />
        <FormLabel :for="`amount${amount}`">
          <MoneyFormat
            class="label-amount"
            :value="amount"
            :currencyCode="form.currency"
            :hide-subunits="true"
          />
          <span class="label-description" v-html="description"></span>
        </FormLabel>
      </div>
    </div> -->

    <h2>Gala tickets:</h2>
    <!-- <div class="promo-codes">
      <input
          id="promoCode"
          type="text"
          name="promoCode"
          placeholder="Promo Code"
          v-model="promoCode"
          style="margin: 0 10px;width: 180px;margin: 0 auto 5px;"
        />
    </div> -->
    <div
      class="yachad-styled styled-radio-container styled-radio-container--ou-donation row"
    >

      <div class="amount-row">
        <input
          id="amount__couple"
          type="checkbox"
          class="amount"
          :checked="individualReservation"
          @click="individualReservation = !individualReservation"
        />
        <FormLabel for="amount__couple">
          <MoneyFormat
            class="label-amount"
            :value="singleTicketPrice"
            :currencyCode="form.currency"
            :hide-subunits="false"
          />
          <span class="label-description">Individual Ticket</span>
          <input
            id="ticketsQnt"
            type="number"
            min="1"
            name="individualReservationQnt"
            placeholder="Quantity"
            v-if="individualReservation"
            v-model="individualReservationQnt"
            style="margin: 0 10px;width: 100px"
          />
        </FormLabel>
      </div>
    </div>

    <ErrorLabel field="amount" />

    <div
      class="clear__btn"
      v-if="form.amount && Number(form.amount) > 0"
      @click="clearOutSelectedValue"
    >
      Clear Selection
    </div>
    <ul class="payment__totals" v-if="form.amount && Number(form.amount) > 0">
      <li class="payment__summary">Summary</li>
      <li v-if="selectedAmount">
        <div class="payment__tot__desc">Sponsorship:</div>
        <div class="payment__tot__amt">
          <span>${{ selectedAmount }}</span>
        </div>
      </li>
      <li v-if="customAmount">
        <div class="payment__tot__desc">Custom Amount:</div>
        <div class="payment__tot__amt">
          <span>${{ customAmount }}</span>
        </div>
      </li>
      <li v-if="form.amount && selectedTickets > 0">
        <div class="payment__tot__desc">Sponsorship Tickets:</div>
        <div class="payment__tot__amt">
          <span>{{selectedTickets}}</span>
        </div>
      </li>
      <li v-if="form.amount && individualReservationQnt > 0">
        <div class="payment__tot__desc">Individual Tickets (${{singleTicketPrice}}):</div>
        <div class="payment__tot__amt">
          <span>{{Number(individualReservationQnt)}}</span>
        </div>
      </li>
      <li v-if="form.amount && Number(form.amount)">
        <div class="payment__tot__desc">Total Amount:</div>
        <div class="payment__tot__amt">
          <span class="pay__total">${{ form.amount }}</span>
        </div>
      </li>
    </ul>
  </section>
</template>
<script lang="ts">
import { computed, defineComponent, type PropType, ref, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

import type { Currency } from "~/form-settings";
import { queryParams } from "~/shared/query-params";

export default defineComponent({  setup() {
    const { setValue, form, settings, getValue } = usePaymentForm();

    const ticketsQnt = ref(0);
    const promoCode = ref();
    const individualReservationQnt = ref(0);
    const selectedAmount = ref(0);
    const totalAmount = ref(0);
    const selectedDescription = ref();
    const customAmount = ref(0);
    const customSelected = ref(false)

    const selectedTickets = ref(0);
    const individualReservation = ref(false)
    const singleTicketPrice = ref(150)

    function clearOutSelectedValue() {
      if (selectedAmount || customAmount) {
        selectedAmount.value = 0;
        customAmount.value = 0;
        customSelected.value = false;
        selectedTickets.value = 0;
        selectedDescription.value = "";
        individualReservation.value = false;
        singleTicketPrice.value = 150
        individualReservationQnt.value = 0
        promoCode.value = null
        ticketsQnt.value = 0
        totalAmount.value = 0
        setValue("amount", null);
        setValue("custom.ticketsQnt", null);
      }
    }

    watch(customAmount, (customAmount) => {
      if (customAmount) {
        selectedAmount.value = 0
        customSelected.value = true
        
        if(customAmount >= 3600) {selectedTickets.value = 10}
        if(customAmount >= 1800 && customAmount < 3600) {selectedTickets.value = 4}
        if(customAmount >= 1250 && customAmount < 1800) {selectedTickets.value = 2}
        if(customAmount < 1250) {selectedTickets.value = 0}

        ticketsQnt.value = Number(selectedTickets.value) + Number(individualReservationQnt.value)
        setValue("custom.ticketsQnt", "" + ticketsQnt.value)

        totalAmount.value = Number(customAmount) + (Number(individualReservationQnt.value) * Number(singleTicketPrice.value));
        setValue('amount', '' + totalAmount.value)
      }
    })

    watch([selectedAmount, selectedDescription], ([selectedAmount, selectedDescription]) => {
      if (selectedAmount) {

        customAmount.value = 0
        customSelected.value = false

        if(selectedAmount == 15000) {selectedTickets.value = 10}
        if(selectedAmount == 10000) {selectedTickets.value = 10}
        if(selectedAmount == 5000) {selectedTickets.value = 10}
        if(selectedAmount == 3600) {selectedTickets.value = 10}
        if(selectedAmount == 2500) {selectedTickets.value = 4}
        if(selectedAmount == 1800) {selectedTickets.value = 4}
        if(selectedAmount == 1250) {selectedTickets.value = 2}
        if(selectedAmount < 1250) {selectedTickets.value = 0}

        ticketsQnt.value = Number(selectedTickets.value) + Number(individualReservationQnt.value)
        setValue("custom.ticketsQnt", "" + ticketsQnt.value)
        setValue("custom.selectedDescription", selectedDescription.value)
        totalAmount.value = selectedAmount +  Number(individualReservationQnt.value) * Number(singleTicketPrice.value);
        setValue("amount", "" + totalAmount.value);
      }
    });
    watch(individualReservationQnt, (individualReservationQnt) => {
      if (individualReservationQnt) {
        ticketsQnt.value = Number(selectedTickets.value) + Number(individualReservationQnt)
        setValue("custom.ticketsQnt", "" + ticketsQnt.value)
        totalAmount.value = Number(selectedAmount.value) + individualReservationQnt * Number(singleTicketPrice.value) + Number(customAmount.value);
        setValue("amount", "" + totalAmount.value);
      }
    });
    watch(promoCode, (promoCode) => {
      if (promoCode == 'Inclusion') {singleTicketPrice.value = 36; setValue("custom.coupon", promoCode);};
      if (promoCode == 'HaimG') {singleTicketPrice.value = 50; setValue("custom.coupon", promoCode);};
      if (promoCode == 'YachadTO') {singleTicketPrice.value = 62.5; setValue("custom.coupon", promoCode);};
      if (promoCode !== 'YachadTO' && promoCode !== 'HaimG' && promoCode !== 'Inclusion') {singleTicketPrice.value = 150; setValue("custom.coupon", promoCode);};

      if (promoCode && ticketsQnt.value > 0) {
        totalAmount.value = Number(selectedAmount.value) + Number(individualReservationQnt.value) * Number(singleTicketPrice.value);
        setValue("amount", "" + totalAmount.value);
      }
    });
    const amounts = computed(() => {
      const amounts = settings!.amounts! as
        | [number, string][]
        | [Partial<{ [key in Currency]: number }>, string][];

      if (typeof amounts[0][0] == "number") return amounts;

      return (amounts as [
        Partial<{ [key in Currency]: number }>,
        string
        //@ts-ignore
      ][]).map(([amounts, label]) => [amounts[form.value.currency!], label]);
    });

    const params = queryParams();

    if (params.amount) {
      //@ts-ignore
      if (
        //@ts-ignore
        amounts.value.includes(+params.amount) ||
        //@ts-ignore
        amounts.value.map((x) => x[0]).includes(+params.amount)
      ) {
        selectedAmount.value = params.amount;
      }
    }

    return {
      form,
      amounts,
      promoCode,
      selectedAmount,
      customSelected,
      customAmount,
      totalAmount,
      ticketsQnt,
      selectedTickets,
      getValue,
      clearOutSelectedValue,
      setValue,
      selectedDescription,
      individualReservation,
      individualReservationQnt,
      singleTicketPrice
    };
  },
});
</script>
<style scoped lang="scss">
.styled-radio-container--ou-donation.styled-radio-container {
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;

  input[type="radio"] {
    height: 0;
    top: 20px;
    position: absolute;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    background: #fff;
    border: 1px solid #ddd;
    font-weight: bold;
    color: rgb(87, 87, 87);
    width: 100%;
    border-radius: 4px;
    cursor: pointer;
    display: block;
    height: 100%;
    display: flex;
    overflow: hidden;
  }
  input[type="radio"]:checked + label {
    background: #0075ff;
    color: white;
  }
  input[type="radio"]:checked + label .label-amount {
    background: #0367de;
    border-color: #1849ff;
  }
  label:hover {
    background: #e9f0f7;
  }
  .amount_other__wrapper {
    position: relative;
    min-width: 22%;
    overflow: hidden;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding-left: 5px;
    flex: 1;
    line-height: 1;
    @media (max-width: 720px) {
      margin-right: 5px;
      margin-left: 5px;
      margin-bottom: 10px;
    }
    &:before {
      content: "$";
      font-weight: 500 !important;
      position: absolute;
      padding: 15px 8px;
      border-right: 1px solid #ddd;
      height: 100%;
      background: #f7f7f7;
      text-align: center;
      top: 0px;
      left: 0;
      width: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    input[type="number"] {
      border: none;
      background: #fff;
      margin-left: 70px;
      box-shadow: none;
      max-width: 85%;
    }
  }
}
input#tickets_qnt {
  background: #fff !important;
  box-shadow: none;
}
.amount-row {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  width: 100%;
  @media (min-width: 720px) {
    min-width: 49%;
    max-width: 49%;
  }
}
.amount {
  margin-right: 7px;
}
.label-amount {
  font-weight: 500;
  display: inline-block;
  padding: 10px 5px 0px;
  align-items: center;
  min-width: 70px;
  max-width: 70px;
  justify-content: center;
  background: #f7f7f7;
  height: 100%;
  display: flex;
  border-right: 1px solid #efefef;
  @media (min-width: 720px) {
    padding: 5px 5px 0px;
  }
}
.amount-row:hover {
  .label-amount {
    border-right: 1px solid #ddd;
    background: #efefef;
  }
}
#amount_other {
  max-width: 200px;
}
::v-deep.label-description {
  font-weight: normal;
  padding: 0px 5px 10px;
  align-items: center;
  justify-content: center;
  height: auto;
  display: flex;
  flex-flow: column;
  text-align: center;
  font-size: 16px;
  gap: 5px;
  line-height: 1.4;
  span {
    font-weight: normal;
    padding: 0px 5px 10px;
    text-transform: none;
    align-items: center;
    justify-content: center;
    height: auto;
    display: flex;
    text-align: center;
    font-size: 12px;
    line-height: 1.4;
  }
}
.yachad-styled.styled-radio-container--ou-donation.styled-radio-container label {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
}
.amount_other__wrapper.amount-row {
  @media (max-width: 720px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
  }
}
.amount-row.tickets-num {
  @media (max-width: 720px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
    margin-top: 10px;
  }
}
::v-deep h1.sponsor__title {
  margin-bottom: 20px;
  margin-top: 0px;
  font-weight: 200;
  font-size: 30px;
  text-transform: uppercase;
  text-align: center;
  color: black;
  @media (max-width: 720px) {
    margin-bottom: 10px;
    font-size: 25px;
  }
}
ul.payment__totals {
  padding: 15px 0px 0px;
  margin: 20px auto 0px;
  max-width: 400px;
  width: 100%;
  border-top: 1px solid #eff2f6;
  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-flow: wrap;
    padding: 0px 0px 4px;
    margin-bottom: 12px;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0.75px;
    color: #4b5866;

    &.payment__summary {
      text-align: center;
      flex: 1;
      width: 100%;
      justify-content: center;
    }
  }

  .payment__tot__desc {
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 15px;
    text-transform: capitalize;
    color: #232e38;
  }
  .payment__tot__amt {
    width: 50%;
    font-size: 14px;
    font-style: italic;
    line-height: 18px;
    text-align: right;
    color: black;
    span {
      display: block;
      &.pay__total {
        font-style: normal;
        font-weight: 600;
      }
    }
  }
}

.clear__btn {
  color: rgba(215, 203, 158, 1);
  border: none;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-size: 13px;
  transition: 0.3s;
  padding: 12px 25px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 20px auto 0px;
  border: 1px solid #e8e8e8;
  max-width: 200px;
  border-radius: 4px;
  &:hover {
    background: #fafafa;
    color: black;
  }
}

.coupon__field {
  display: flex;
  justify-content: center;
  flex-flow: column;
  align-items: center;
  margin-top: 24px;
  ::v-deep .control-label {
    padding-bottom: 5px;
  }
}
.discount-label {
  color: #333;
  text-decoration: line-through;
}
p.special {
  font-weight: bold;
  text-align: center;
  margin-top: 40px;
}

::v-deep h3.sponsor__subtitle {
  margin-bottom: 15px;
  margin-top: 40px;
  font-weight: 200;
  font-size: 22px;
  text-transform: uppercase;
  text-align: center;
  color: black;
}

.amount_other__wrapper.amount-row {
  margin: auto;
}

.amount_other__wrapper.amount-row {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    padding: 6px 6px 6px;
    max-width: 50% !important;
}

.amount_other__wrapper.amount-row label {
    text-transform: uppercase;
    font-size: 16px;
    color: #131232!important;
}
</style>
